module.exports = __webpack_public_path__ + "static/media/comunicado-mobile.59494c5f.png";